export const sales = {
  title: 'Sales',
  subtitle: 'Point of Sale system',
  pos: 'POS',
  
  warehouse: {
    title: 'Select sales location',
    all: 'All',
    allDescription: 'Shows inventory from all warehouses/stores',
    unknown: 'Unknown warehouse',
    storage: 'Warehouse'
  },
  
  categories: {
    title: 'Categories',
    all: 'All categories',
    subcategories: 'Subcategories',
    clearFilters: 'Clear filters'
  },
  
  products: {
    title: 'Products',
    search: 'Search products (name, code)...',
    loadingOrAddRequired: 'Products need to be loaded or added',
    clearFilters: 'Clear filters',
    noImage: 'No image',
    service: 'Service',
    inactive: 'Inactive',
    nextPage: 'Next page',
    previousPage: 'Previous page'
  },
  
  cart: {
    title: 'Cart',
    empty: 'Empty cart',
    summary: 'Summary',
    netAmount: 'Net amount',
    vat: 'VAT',
    totalAmount: 'Total amount',
    paymentMethod: 'Payment method',
    cash: 'Cash',
    card: 'Card',
    transfer: 'Transfer',
    sellButton: 'Complete sale and issue invoice'
  },
  
  stock: {
    outOfStock: 'Out of stock',
    insufficientStock: 'Insufficient stock',
    stockRequired: 'Warehouse selection required',
    available: 'pcs available',
    inStock: 'In stock',
    transferable: 'Transferable stock',
    noStock: 'No stock',
    transfer: {
      title: 'Inter-warehouse transfer',
      request: 'Request',
      sent: 'Transfer request sent',
      success: 'transfer completed'
    }
  },
  
  browsing: {
    title: 'Browse mode',
    description: 'You are viewing inventory from all warehouses.',
    instruction: 'To sell, please select a specific warehouse from the list above.',
    legend: {
      green: 'Green = Product in stock',
      orange: 'Orange = Transferable stock',
      red: 'Red = Out of stock'
    }
  },
  
  messages: {
    success: {
      saleCompleted: 'Sale completed',
      saleRecorded: 'Sale has been successfully recorded in the system!',
      invoiceGenerated: 'Invoice generated',
      stockTransferSent: 'Transfer request sent'
    },
    warning: {
      warehouseRequired: 'Warehouse selection required',
      selectWarehouse: 'Please select a specific warehouse for sales.',
      insufficientStock: 'Insufficient stock',
      onlyAvailable: 'Only {{count}} pcs available in this warehouse.',
      missingStock: 'Missing stock: {{product}}'
    },
    error: {
      noStock: 'No stock',
      noStockAnyWarehouse: 'This product is out of stock in all warehouses.',
      invoiceError: 'Invoice generation error',
      invoiceFailed: 'Failed to generate invoice',
      unknownError: 'Unknown error'
    }
  },
  
  customer: {
    default: 'Customer',
    country: 'Hungary'
  },
  
  currency: 'HUF',
  unit: 'pcs'
}; 